import {
  LCMSupportedProduct,
  PolicyProduct,
  SizingGroups
} from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { LcopsApiUri } from './uri';

interface ProductPolicyCache {
  productPolicies?: {
    // Caching like productId:version
    [productVersion: string]: SizingGroups;
  };
}

type CachedItem = keyof ProductPolicyCache;

export class ProductPolicyApi {
  private static productPolicyCache: ProductPolicyCache = {
    productPolicies: {}
  };

  public static async getProductPolicies(vcfEnabledEnvironment?: boolean) {
    const products = await Http.get<PolicyProduct[]>(
      LcopsApiUri.ProductPolicy.GET_ALL_PRODUCTS_POLICY_URL(
        vcfEnabledEnvironment
      )
    );
    return products.data;
  }

  public static async getLcmSupportedProduct(isVcfUser?: boolean) {
    let getSupportedProductVersionsUrl =
      LcopsApiUri.ProductPolicy.GET_SUPPORTED_PRODUCT_VERSIONS_URL;

    if (isVcfUser) {
      getSupportedProductVersionsUrl += `?isUpgradeFlow=${isVcfUser}`; // skip level upgrade
    }
    const response = await Http.get<LCMSupportedProduct[]>(
      getSupportedProductVersionsUrl
    );
    return response.data;
  }

  public static async getProxyPolicies() {
    const response = await Http.get<PolicyProduct[]>(
      LcopsApiUri.GET_ALL_PROXY_POLICY
    );
    return response.data;
  }

  public static async getSizingGroups(productId: string, version: string) {
    const { productPolicies } = ProductPolicyApi.productPolicyCache;
    if (productPolicies && productPolicies[`${productId}:${version}`]) {
      return productPolicies[`${productId}:${version}`];
    }

    const response = await Http.get<SizingGroups>(
      LcopsApiUri.ProductPolicy.GET_PRODUCT_SIZING_GROUPS_URL(
        productId,
        version
      )
    );
    if (!ProductPolicyApi.productPolicyCache.productPolicies) {
      ProductPolicyApi.productPolicyCache.productPolicies = {};
    }
    ProductPolicyApi.productPolicyCache.productPolicies[
      `${productId}:${version}`
    ] = response.data;
    return response.data;
  }

  public static clearCache() {
    ProductPolicyApi.productPolicyCache = { productPolicies: {} };
  }

  public static clearCachedItem(item: CachedItem) {
    delete ProductPolicyApi.productPolicyCache[item];
  }
}
